import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: [
    'DV_DP_unavailable_page_message',
    'DV_DP_only_playback_available_in_gen4_message',
  ] as const,
}
